import {
  Card,
  CardContent,
  Stack,
  Typography,
  Divider,
  Grid,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import { Device } from '../../../store/reducers/deviceReducers';
import { useDispatch } from 'react-redux';
import { fetchGroups } from '../../../store/actions/groupActions';
import { updateGroup } from '../../../store/actions/deviceActions';
import deviceApi from '../../../api/devices';

const GroupInfo = ({ device }: { device: Device }) => {
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const groups = useSelector((state: any) => state.group.groups);

  const handleEdit = async () => {
    if (!edit) {
      setEdit(true);
      dispatch({ type: fetchGroups.request });
      return;
    }
    setEdit(!edit);
    setLoading(true);
    await deviceApi.putTarget(device.target.id, {
      group_id: device.group.id,
    })();
    setLoading(false);
    setEdit(false);
  };

  const handleChange = (value: number) => {
    dispatch(updateGroup({ serial: device.serial, group: groups.find((g) => g.id === value) }));
  };

  return (
    <Card elevation={2} sx={{ height: '100%', borderRadius: 2 }}>
      <CardContent>
        <Stack spacing={3}>
          <Stack direction='row' alignItems='center' justifyContent='space-between'>
            <Stack direction='row' alignItems='center' spacing={1}>
              <GroupWorkIcon color='primary' />
              <Typography variant='h6'>Group Information</Typography>
            </Stack>
            <Button
              startIcon={edit ? <SaveIcon /> : <EditIcon />}
              size='small'
              variant='outlined'
              disabled={loading}
              onClick={() => handleEdit()}
            >
              {edit ? 'Save' : 'Edit'}
            </Button>
          </Stack>
          <Divider />
          {edit ? (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant='body2' color='text.secondary' gutterBottom>
                  Select Group
                </Typography>
                <Select
                  fullWidth
                  value={device.group.id}
                  onChange={(e) => handleChange(Number(e.target.value))}
                  size='small'
                >
                  {groups.map((group: any) => (
                    <MenuItem key={group.id} value={group.id}>
                      {group.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant='body2' color='text.secondary'>
                  Group ID
                </Typography>
                <Typography variant='body1' fontWeight='medium'>
                  {device.group.id}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant='body2' color='text.secondary'>
                  Group Name
                </Typography>
                <Typography variant='body1' fontWeight='medium'>
                  {device.group.name}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default GroupInfo;
